export default __webpack_public_path__ + "static/media/DCU.01c4a156.jpeg";